//#region src/process.js
function nextTick(fun, ...args) {
	if (args.length > 0) queueMicrotask(() => fun(...args));
	else queueMicrotask(fun);
}
var title = "browser";
var platform = "browser";
var browser = true;
var env = {};
var argv = [];
var version = "";
var versions = {};
var release = {};
var config = {};
function noop() {}
var on = noop;
var addListener = noop;
var once = noop;
var off = noop;
var removeListener = noop;
var removeAllListeners = noop;
var emit = noop;
function binding(name) {
	throw new Error("process.binding is not supported");
}
function cwd() {
	return "/";
}
function chdir(dir) {
	throw new Error("process.chdir is not supported");
}
function umask() {
	return 0;
}
var performance = globalThis.performance || {};
var performanceNow = performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow || function() {
	return (/* @__PURE__ */ new Date()).getTime();
};
function hrtime(previousTimestamp) {
	var clocktime = performanceNow.call(performance) * .001;
	var seconds = Math.floor(clocktime);
	var nanoseconds = Math.floor(clocktime % 1 * 1e9);
	if (previousTimestamp) {
		seconds = seconds - previousTimestamp[0];
		nanoseconds = nanoseconds - previousTimestamp[1];
		if (nanoseconds < 0) {
			seconds--;
			nanoseconds += 1e9;
		}
	}
	return [seconds, nanoseconds];
}
hrtime.bigint = function() {
	var clocktime = performanceNow.call(performance) * .001;
	var seconds = Math.floor(clocktime);
	var nanoseconds = Math.floor(clocktime % 1 * 1e9);
	return BigInt(seconds * 1e9) + BigInt(nanoseconds);
};
var startTime = /* @__PURE__ */ new Date();
function uptime() {
	return (/* @__PURE__ */ new Date() - startTime) / 1e3;
}
var process = {
	nextTick,
	title,
	browser,
	env,
	argv,
	version,
	versions,
	on,
	addListener,
	once,
	off,
	removeListener,
	removeAllListeners,
	emit,
	binding,
	cwd,
	chdir,
	umask,
	hrtime,
	platform,
	release,
	config,
	uptime
};
var defines = {};
Object.keys(defines).forEach((key) => {
	const segs = key.split(".");
	let target = process;
	for (let i = 0; i < segs.length; i++) {
		const seg = segs[i];
		if (i === segs.length - 1) target[seg] = defines[key];
		else target = target[seg] || (target[seg] = {});
	}
});
//#endregion
export { process };

//# sourceMappingURL=process.mjs.map